'use strict';

var _classCallCheck = require("/builds/a8-megtag/a8chat-console-web/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/builds/a8-megtag/a8chat-console-web/node_modules/react-scripts/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/a8-megtag/a8chat-console-web/node_modules/react-scripts/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/a8-megtag/a8chat-console-web/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var Node = require('./node');

var Comment = /*#__PURE__*/function (_Node) {
  _inherits(Comment, _Node);

  function Comment(defaults) {
    var _this;

    _classCallCheck(this, Comment);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Comment).call(this, defaults));
    _this.type = 'comment';
    return _this;
  }

  return Comment;
}(Node);

module.exports = Comment;
Comment.default = Comment;